import { Braces, KeyRound, ScrollText, StickyNote } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { ITEM_TYPES, isItemType } from "../../vaultPayload.js";
import type { ItemType } from "../../vaultPayload.js";

export interface ItemTypeInfo {
  readonly type: ItemType;
  readonly icon: LucideIcon;
  /** Plural, for filters and page titles. */
  readonly plural: string;
}

const INFO: Readonly<Record<ItemType, ItemTypeInfo>> = {
  login: { type: "login", icon: KeyRound, plural: "Logins" },
  apiKey: { type: "apiKey", icon: Braces, plural: "API-Schlüssel" },
  license: { type: "license", icon: ScrollText, plural: "Softwarelizenzen" },
  note: { type: "note", icon: StickyNote, plural: "Sichere Notizen" }
};

export const TYPE_INFOS: ReadonlyArray<ItemTypeInfo> = ITEM_TYPES.map((type: ItemType): ItemTypeInfo => INFO[type]);

export function typeInfo(type: ItemType): ItemTypeInfo {
  return INFO[type];
}

/** Reads ?type= from the URL; anything unknown means "all types". */
export function typeFromParam(value: string | null): ItemType | undefined {
  return isItemType(value) ? value : undefined;
}
